import * as React from "react"
import { ImageCdn } from "./ImageCdn"
import {
  SettingsCard,
  SettingsCardTitle,
  SettingsCardContent,
  SettingsCardEditButton,
} from "@modules/site/settings"
import { imageCdnIntegrationConfig as text } from "@modules/locales/default.js"

export type ImageCdnIntegrationProps = {
  siteId: string
  organizationId: string
}

export function ImageCdnIntegration({
  siteId,
  organizationId,
}: ImageCdnIntegrationProps) {
  return (
    <SettingsCard>
      <SettingsCardTitle>{text.headers.images}</SettingsCardTitle>
      <SettingsCardEditButton
        onClick={() => {
          window.open("https://gatsby.dev/vp5")
        }}
        data-cy="share-feedback-button"
        label={text.messages.shareFeedback}
        showIcon={false}
      />
      <SettingsCardContent>
        <ImageCdn siteId={siteId} organizationId={organizationId} />
      </SettingsCardContent>
    </SettingsCard>
  )
}
